import { render, staticRenderFns } from "./StockAlertTable.vue?vue&type=template&id=5895493c&scoped=true"
import script from "./StockAlertTable.vue?vue&type=script&lang=js"
export * from "./StockAlertTable.vue?vue&type=script&lang=js"
import style0 from "./StockAlertTable.vue?vue&type=style&index=0&id=5895493c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895493c",
  null
  
)

export default component.exports